import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuggestTagDialogComponent } from './suggest-tag-dialog/suggest-tag-dialog.component';
import { SharedPipesModule } from 'app/shared-pipes/shared-pipes.module';
import { MatButtonModule, MatInputModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    SharedPipesModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [SuggestTagDialogComponent],
  entryComponents: [SuggestTagDialogComponent],
  exports: [SuggestTagDialogComponent],
})
export class SuggestTagDialogModule {}
